import { connect } from "react-redux";
import { cartsChanged } from "../../../store/action/cart";
import CartService from "../../../services/cart/Cart";
import Card from "../../../components/card";
import CheckBox from "../../../components/checkbox/Checkbox";
import {
  Div,
  ShippingTitle,
  ShippingMsg,
  ShippingIcon,
  CardLink,
} from "./style";

const Shipping = (props) => {
  const { carts, theme, cartsChanged, data } = props;

  const selectShipping = (name = "shipping", value = data, e) => {
    if (e) {
      e.preventDefault();

      name = "shipping";
      value = data;
    }

    CartService.changed(carts, name, value, cartsChanged);
  };

  return (
    <>
      <Card className="p-3 text-right" onClick={selectShipping}>
        <CardLink href="/" onClick={(e) => selectShipping(false, false, e)}>
          <Div className="d-inline-block vertical-align-top mt-1">
            <CheckBox
              name="shipping"
              value={data}
              onChange={selectShipping}
              checked={carts.shipping?.id === data.id ? true : false}
            />
          </Div>
          <Div className="d-inline-block mr-2">
            <ShippingTitle className="d-block mb-1" theme={theme}>
              {data.name}
            </ShippingTitle>
            <ShippingMsg className="d-block" theme={theme}>
              {data.description}
            </ShippingMsg>
          </Div>
          <Div className="d-inline-block float-left">
            <ShippingIcon className={`${data.icon_text} f-35`}></ShippingIcon>
          </Div>
        </CardLink>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    carts: state.carts?.carts,
  };
};

export default connect(mapStateToProps, { cartsChanged })(Shipping);
